import { Box } from "@mui/material";

interface AppLayoutHeaderWrapperDesktopProps {
  children: React.ReactNode;
}

/**
 * Wrapper for the header of the app layout
 * Renders above the inner content (nav menu and page content) and wraps the header content
 */
export function AppLayoutHeaderWrapperDesktop(props: AppLayoutHeaderWrapperDesktopProps) {
  const { children } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 0,
        height: "62px",
        flexShrink: 0,
      }}
    >
      {children}
    </Box>
  );
}
